import { FREE_LIMITS } from '@dayflow/shared'

// Los valores vienen del paquete compartido: son los mismos que aplica el servidor.
export const PLAN_LIMITS = {
  free: {
    workspaces: FREE_LIMITS.workspaces,
    habitos: FREE_LIMITS.habits,
    notas: FREE_LIMITS.notes,
    tareasDiarias: FREE_LIMITS.activeTasks,
    aiFeatures: false,
    rutinasGimnasio: FREE_LIMITS.routines,
  },
  premium: {
    workspaces: Infinity,
    habitos: Infinity,
    notas: Infinity,
    tareasDiarias: Infinity,
    aiFeatures: true,
    rutinasGimnasio: Infinity,
  }
}

export const canCreateResource = (resourceType, currentCount, plan = 'free') => {
  const limits = PLAN_LIMITS[plan] || PLAN_LIMITS.free
  const limit = limits[resourceType]

  if (limit === undefined) return true
  return currentCount < limit
}

export const canUseAIFeatures = (plan = 'free') => {
  const limits = PLAN_LIMITS[plan] || PLAN_LIMITS.free
  return limits.aiFeatures
}
